import { useEffect, useRef } from 'react'

const useSlide = (containerRef, trayRef, spec) => {
  let handler = useRef()

  handler.current = () => {
    let containerWidth = containerRef.current.offsetWidth
    let slidesPerView = spec.slidesPerView
    let width =
      slidesPerView === 'auto' ? '' : containerWidth / slidesPerView + 'px'

    for (let slide of Array.from(trayRef.current.children)) {
      slide.style.width = width
    }
  }

  useEffect(() => {
    handler.current()
  }, [spec])

  useEffect(() => {
    let container = containerRef.current

    let observer = new ResizeObserver(() => {
      handler.current()
    })

    observer.observe(container)

    return () => {
      observer.unobserve(container)
    }
  }, [containerRef])
}

export default useSlide
